import { render, staticRenderFns } from "./matter-component.vue?vue&type=template&id=e5474d7c"
import script from "./matter-component.vue?vue&type=script&lang=js"
export * from "./matter-component.vue?vue&type=script&lang=js"
import style0 from "./matter-component.vue?vue&type=style&index=0&id=e5474d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports